import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["authMode", "apiTokenGroup", "basicGroup", "apiTokenInput", "basicUsernameInput", "basicPasswordInput"]

  connect() {
    this.updateVisibility()
  }

  authModeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const mode = this.authModeTarget.value
    const needsToken = ["bearer", "x_api_key", "query_token"].includes(mode)
    const needsBasic = mode === "basic"

    this.toggleGroup(this.apiTokenGroupTarget, needsToken)
    this.toggleGroup(this.basicGroupTarget, needsBasic)

    this.apiTokenInputTarget.required = needsToken
    this.basicUsernameInputTarget.required = needsBasic
    this.basicPasswordInputTarget.required = needsBasic
  }

  toggleGroup(group, visible) {
    const inputs = group.querySelectorAll("input, select, textarea")
    if (visible) {
      group.classList.remove("d-none")
      inputs.forEach((input) => {
        input.disabled = false
      })
    } else {
      group.classList.add("d-none")
      inputs.forEach((input) => {
        input.disabled = true
      })
    }
  }
}
